module.exports = __webpack_public_path__ + "static/dotnet-99ba4a3b8f3df3b45973170937216530.png";